import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option"]

  connect() {
    this.updateSelection()
  }

  select(event) {
    const option = event.currentTarget
    
    // Fallback: Direkt auf das Element klicken
    if (!option) {
      return
    }
    
    const radio = option.querySelector('input[type="radio"]')
    
    if (!radio) {
      return
    }
    
    // Radio-Button auswählen
    radio.checked = true
    radio.dispatchEvent(new Event('change', { bubbles: true }))
    
    // Alle Optionen zurücksetzen
    this.optionTargets.forEach(opt => {
      opt.classList.remove('border-button', 'bg-blue-50')
      opt.classList.add('border-transparent', 'bg-gray-50')
      
      // Alle Indikatoren in dieser Option verstecken
      const indicators = opt.querySelectorAll('.w-3.h-3.rounded-full.bg-button')
      indicators.forEach(ind => ind.classList.add('hidden'))
    })
    
    // Ausgewählte Option hervorheben
    option.classList.remove('border-transparent', 'bg-gray-50')
    option.classList.add('border-button', 'bg-blue-50')
    
    // Indikator der ausgewählten Option anzeigen
    const selectedIndicator = option.querySelector('.w-3.h-3.rounded-full.bg-button')
    if (selectedIndicator) {
      selectedIndicator.classList.remove('hidden')
    }
  }

  updateSelection() {
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked')
    
    if (checkedRadio) {
      const option = checkedRadio.closest('.radio-option')
      if (option) {
        this.select({ currentTarget: option })
      }
    }
  }
}